export type PdfViewerProps = {
    fileName: string;
    url: string;
};

const PdfViewer = ({ fileName, url }: PdfViewerProps) => {
    return (
        <iframe
            title={fileName}
            width={'100%'}
            height={'100%'}
            src={'/pdf/web/?file=' + url}></iframe>
    );
};

export default PdfViewer;
